module.exports = __webpack_public_path__ + "fonts/DINPro.26790dcd.otf";